<div *ngIf="show()" class="page-loading" [@enterAnimation]>
  <app-spinner class="is-page"></app-spinner>
</div>
